import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
// import Table from '@/gui/Table'
import DatagridCell from './DatagridCell' // eslint-disable-line
import DatagridHeaderCell from './DatagridHeaderCell'
import DatagridBody from './DatagridBody'
// import { Table } from '@/ui/Table'

// import tableTheme from '@/styles/parts/table.css'

/**
 * The Datagrid component renders a list of records as a table.
 * It is usually used as a child of the <List> and <ReferenceManyField> components.
 *
 * Props:
 *  - styles
 *  - rowStyle
 *  - options (passed as props to <Table>)
 *  - headerOptions (passed as props to <TableHeader>)
 *  - bodyOptions (passed as props to <TableBody>)
 *  - rowOptions (passed as props to <TableRow>)
 *
 * @example Display all posts as a datagrid
 * const postRowStyle = (record, index) => ({
 *     backgroundColor: record.nb_views >= 500 ? '#efe' : 'white',
 * });
 * export const PostList = (props) => (
 *     <List {...props}>
 *         <Datagrid rowStyle={postRowStyle}>
 *             <TextField source="id" />
 *             <TextField source="title" />
 *             <TextField source="body" />
 *             <EditButton />
 *         </Datagrid>
 *     </List>
 * );
 *
 * @example Display all the comments of the current post as a datagrid
 * <ReferenceManyField reference="comments" target="post_id">
 *     <Datagrid>
 *         <TextField source="id" />
 *         <TextField source="body" />
 *         <DateField source="created_at" />
 *         <EditButton />
 *     </Datagrid>
 * </ReferenceManyField>
 */
class Datagrid extends Component {
  updateSort = event => {
    event.stopPropagation()
    this.props.setSort(event.currentTarget.dataset.sort)
  }

  render() {
    const {
      resource,
      children,
      ids,
      isLoading,
      data,
      currentSort,
      theme,
      headerOptions,
      bodyOptions,
      rowOptions,
      sortable = true,
      startingNo,
    } = this.props
    const withoutThead = headerOptions && headerOptions.hide

    return (
      <table
        className={classNames(theme.table, {
          [theme['without-thead']]: withoutThead,
          [theme['sortable']]: sortable,
        })}
      >
        <If condition={!withoutThead}>
          <thead>
            <tr>
              {React.Children.map(children, (field, index) => (
                <DatagridHeaderCell
                  key={field.props.source || index}
                  field={field}
                  width={field.props.width || 'auto'}
                  currentSort={currentSort}
                  isSorting={field.props.source === currentSort.field}
                  updateSort={this.updateSort}
                  resource={resource}
                  theme={theme}
                />
              ))}
            </tr>
          </thead>
        </If>
        <DatagridBody
          resource={resource}
          ids={ids}
          data={data}
          isLoading={isLoading}
          options={bodyOptions}
          rowOptions={rowOptions}
          startingNo={startingNo}
          theme={theme}
        >
          {children}
        </DatagridBody>
      </table>
    )
  }
}

Datagrid.propTypes = {
  bodyOptions: PropTypes.object,
  currentSort: PropTypes.shape({
    sort: PropTypes.string,
    order: PropTypes.string,
  }),
  data: PropTypes.object.isRequired,
  headerOptions: PropTypes.object,
  ids: PropTypes.arrayOf(PropTypes.any).isRequired,
  isLoading: PropTypes.bool,
  theme: PropTypes.object.isRequired,
  resource: PropTypes.string,
  rowOptions: PropTypes.object,
  setSort: PropTypes.func,
}

Datagrid.defaultProps = {
  data: {},
  ids: [],
  theme: {},
}

export default Datagrid



// WEBPACK FOOTER //
// ./ui/DataTable/Datagrid.js